import { isNumber, uid } from 'radash';

import {
    ComponentInstanceValidationError,
    ComponentInstanceValidationErrorType,
    ComponentInstanceValidator,
    ComponentType,
    DiagramConnection,
} from 'models';

// The simulator models the DC ports of these components with two terminals, so a port wired with
// L+, M and L- leaves one conductor unconstrained and the power flow fails to set up.
const TWO_TERMINAL_COMPONENT_TYPES: ComponentType[] = [
    'battery',
    'capacitor',
    'charger',
    'converter',
    'custom',
    'diode',
    'fuelCell',
    'generator',
    'hvac',
    'hydro',
    'light',
    'load',
    'motor',
    'solar',
    'solution',
    'transformer',
    'utility',
    'wind',
];

const dcPortLines: ComponentInstanceValidator['validator'] = ({ diagram }) => {
    const errors: ComponentInstanceValidationError[] = [];

    Object.values(diagram.connections).forEach((connection) => {
        if (!connectsAllDcLines(connection)) {
            return;
        }

        [connection.from, connection.to].forEach(({ componentInstanceId, port }) => {
            const componentInstance = diagram.componentInstances[componentInstanceId];

            if (!componentInstance || componentInstance.disabled || !isNumber(port)) {
                return;
            }

            if (!TWO_TERMINAL_COMPONENT_TYPES.includes(componentInstance.componentType)) {
                return;
            }

            if (componentInstance.configuration.ports[port]?.voltageType !== 'DC') {
                return;
            }

            errors.push({
                id: uid(6),
                type: ComponentInstanceValidationErrorType.INVALID_CONFIGURATION_DC_PORT_LINES,
                level: 'error',
                payload: { componentInstance, portIndex: port },
            });
        });
    });

    return errors;
};

const connectsAllDcLines = ({ lines }: DiagramConnection) => lines.DC['L+'] && lines.DC.M && lines.DC['L-'];

export { dcPortLines };
